class Validator {
  private usUsdRoutingNumberRegex = /^\d{9}$/

  private calculateABAChecksum(routingNumber: string): boolean {
    const digits = routingNumber.split('').map(Number)
    const checksum =
      3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      1 * (digits[2] + digits[5] + digits[8])

    return checksum % 10 === 0
  }

  isValidRoutingNumber(value: string, invalidFormatMessage: string ): string | boolean {
    const isValidFormat: boolean = this.usUsdRoutingNumberRegex.test(value)
    if (!isValidFormat) {
      return invalidFormatMessage
    }

    const passesChecksum: boolean = this.calculateABAChecksum(value)
    if (!passesChecksum) {
      return invalidFormatMessage
    }

    return true
  }

}

export default Validator;